@if((loader$ | async)?.visible) {
  <div class="spinner" [style.z-index]="(loader$ | async)?.zIndex">
    <div class="div-center-screen-size-100-100">
      <img class="rotate360-5s img-fluid max-width-4rem" src="assets/images/loading_static_grey.png" alt="Loading ..."/>
    </div>
  </div>
}